// ============================================================
// CENTRAL CONFIGURATION — Edit everything about the site here.
// Phone numbers, WhatsApp, address, map, socials, photos.
// ============================================================

// Production domain (set in frontend/.env as REACT_APP_SITE_URL)
export const SITE_URL = process.env.REACT_APP_SITE_URL;

const WHATSAPP_MESSAGE =
  "Hello Dr. Suyash Bhadoriya, I would like to book a consultation. Please let me know the available appointment timings.";

export const DOCTOR = {
  name: "Dr. Suyash Bhadoriya",
  qualifications: "MBBS, MD (Internal Medicine), CCEBDM",
  role: "Assistant Professor",
  designation: "General Physician & Internal Medicine Specialist",

  // ---- Contact (editable) ----
  clinicPhoneDisplay: "0755-3100126",
  clinicPhoneHref: "tel:07553100126",
  mobileDisplay: "9009147999",
  mobileHref: "tel:+919009147999",
  whatsappNumber: "919009147999", // country code + number, no +
  whatsappMessage: WHATSAPP_MESSAGE,

  // ---- Location (editable) ----
  city: "Bhopal, Madhya Pradesh",
  hospitalName: "Shree Multispeciality Hospital",
  addressLine1: "271/2A, Saket Nagar",
  addressLine2: "Near AIIMS Gate No. 3, Habib Ganj",
  addressLine3: "Bhopal, Madhya Pradesh 462024, India",
  // Paste a Google Maps embed URL here to override the automatic one:
  mapsEmbedUrl: "",
  mapsQuery:
    "Shree Multispeciality Hospital, Saket Nagar, Habib Ganj, Bhopal, Madhya Pradesh 462024",

  // ---- OPD timings ----
  opdTime: "4:00 PM – 7:30 PM",
  opdDays: "Monday – Friday",
  opdSunday: "Sunday: 1:00 PM – 3:00 PM",
  opdOff: "Saturday Closed",

  // ---- Photos (in /public/assets) ----
  photoHero: "/assets/doctor-portrait.jpg",
  photoOffice: "/assets/doctor-clinic.jpg",

  // ---- Google Business Profile (local SEO & trust) ----
  googleProfileUrl: "https://share.google/41A7z8EqMRJXiq8E4",

  // ---- Social links (leave blank to hide; do not invent URLs) ----
  socials: {
    instagram:
      "https://www.instagram.com/doctor.ki_kahani?igsi=anFmaTJzNHJoNHdk",
    facebook: "https://www.facebook.com/share/1DMudAGDAe/",
    youtube: "https://youtube.com/@suyashbhadoriya4663?si=A0JZQ4eusihEt1AW",
    linkedin: "",
  },
};

export const whatsappLink = (message = DOCTOR.whatsappMessage) =>
  `https://wa.me/${DOCTOR.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const mapsEmbedSrc = () =>
  DOCTOR.mapsEmbedUrl ||
  `https://www.google.com/maps?q=${encodeURIComponent(DOCTOR.mapsQuery)}&output=embed`;

export const mapsDirectionsLink = () =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    DOCTOR.mapsQuery
  )}`;

export const fullAddress = () =>
  `${DOCTOR.hospitalName}, ${DOCTOR.addressLine1}, ${DOCTOR.addressLine2}, ${DOCTOR.addressLine3}`;
